export default {
  displayName: 'Attention Bar',
  allowableParents: [],
  migrator: data => {
    if (data && !data.layout) {
      data = { ...data, layout: 'custom' };
    }
    data = { 
      ...data,
      component: 'AttentionBarPicker',
      settings: {
        ...data?.settings,
        attentionBarType: data?.settings?.attentionBarType ?? 'noImage',
        closeButton: data?.settings?.closeButton ?? false,
      },
    };
    if (data.layout === 'multiCTA') {
      data = { ...data, copy: { heading: data.heading?.heading } };
    }
    return data;
  },
};
